import { insertFumigationCompanyService } from "services/insertFumigationCompany.service";
import { FumigationCompanyPayload, FumigationCompanyDetail } from "services/fumigationCompany.types";
import { useMutation } from "react-query";
import { AxiosError } from 'axios';

// POST /fumigator-details -> server responds with { data: <created row> }
export interface InsertFumigationCompanyResponse {
    data: FumigationCompanyDetail;
}

export const useInsertFumigationCompany = () => {

    return useMutation<InsertFumigationCompanyResponse, AxiosError, FumigationCompanyPayload>(insertFumigationCompanyService);

}

export default useInsertFumigationCompany;
